import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=42b7cf52&scoped=true&"
import script from "./Ranking.vue?vue&type=script&lang=js&"
export * from "./Ranking.vue?vue&type=script&lang=js&"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=42b7cf52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7cf52",
  null
  
)

export default component.exports